import { mix } from "@chorda/core";
export const Addon = (props) => {
    return mix({
        css: 'control',
        weight: props.weight,
        templates: {
            content: props.content
        },
        defaults: {
            name: () => props.name
        }
    });
};
